import React from "react";
import { Link } from "react-router-dom";
import { PowerOff } from "lucide-react";
import { useAuth } from "../../contexts/AuthContext";
import { useSiteStatus } from "../../contexts/SiteStatusContext";

/**
 * Thin sticky banner shown ONLY to the admin whenever the site is paused —
 * so they can never forget the kill-switch is on. Click to jump to the
 * profile where the resume button lives.
 */
export default function AdminPausedBanner() {
  const { user } = useAuth();
  const { paused } = useSiteStatus();
  if (!paused || !user?.is_admin) return null;
  return (
    <Link
      to="/profile"
      data-testid="admin-paused-banner"
      className="sticky top-0 z-[70] block w-full text-center text-[12px] font-mono-p py-2 px-4 bg-[#ff9c85]/15 text-[#ffb097] border-b border-[#ff9c85]/30 hover:bg-[#ff9c85]/20 transition-colors"
    >
      <span className="inline-flex items-center gap-2">
        <PowerOff className="w-3.5 h-3.5" />
        <span className="uppercase tracking-[0.2em]">Site paused</span>
        <span className="opacity-70">— you can still work. Click to resume.</span>
      </span>
    </Link>
  );
}
